module.exports = __webpack_public_path__ + "img/artic1_sample.fa49457b.png";